var map = {
	"./IMG_1308.PNG": 221,
	"./IMG_1310.PNG": 2666,
	"./IMG_1317.PNG": 3045,
	"./IMG_1318.PNG": 8178,
	"./IMG_1488.PNG": 3154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3099;